import { useState, useEffect, useCallback } from 'react';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';

/**
 * Fetches a user's pick history by uid (for public profile view).
 * Returns resolved + cancelled picks sorted by most recent first.
 */
export function usePublicPickHistory(uid) {
  const [picks, setPicks] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPicks = useCallback(async () => {
    if (!uid) {
      setPicks([]);
      setLoading(false);
      return;
    }

    try {
      const q = query(
        collection(db, 'picks'),
        where('uid', '==', uid),
        where('isActive', '==', false),
        orderBy('createdAt', 'desc')
      );

      const snapshot = await getDocs(q);
      const results = snapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
      setPicks(results);
    } catch (err) {
      console.error('Error fetching public pick history:', err);
    } finally {
      setLoading(false);
    }
  }, [uid]);

  useEffect(() => {
    fetchPicks();
  }, [fetchPicks]);

  return { picks, loading };
}
